import { Component, Input } from "@angular/core";
import { NotificationListConfig, User } from "../../../../models";

@Component({
  selector: "notification-alert-button",
  templateUrl: "./notification-alert-button.component.html",
  styleUrls: [
    "./notification-alert-button.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class NotificationAlertButtonComponent {
  public hasNotifications: boolean = false;
  @Input() limit: number;
  @Input() config: NotificationListConfig;
  @Input() currentUser: User;

  constructor() {}

  ngOnInit() {}

  public alertUser(event) {
    this.hasNotifications = event;
  }
}
